import { Box, Typography, Paper } from "@mui/material";

import "./MyPerformance.scss";
import Loader from "../Loader";

import MyPerformanceHeader from "./MyPerformanceHeader";
import DashboardRenderer from "./Dashboard/DashboardRenderer";
import MyPerformanceWelcomeBanner from "./MyPerformanceWelcomeBanner";
import RoleMyPerformanceView from "./views/RoleMyPerformanceView";
import { getRoleViewConfig } from "./views/roleViewConfig";
import { useMyPerformanceController } from "./useMyPerformanceController";

function MyPerformance({ isActive = true }) {
  const {
    showLoader,
    widgetProps,
    headerProps,
    isLeadership,
    firstName,
    displayIdentityLoading,
    roleKey,
    effectiveSelectedProduct,
    onExploreHcpClick,
  } = useMyPerformanceController({ isActive });
  // SALESREP + RBD use the tabbed, config-driven view (hero + pill tabs).
  // Other roles (LEADERSHIP) keep the legacy single-grid dashboard.
  const roleViewConfig = getRoleViewConfig(roleKey);
  const useTabbedView = Boolean(roleViewConfig);

  return (
    <>
      {showLoader && <Loader />}
      <Box
        sx={{
          position: "sticky",
          top: "142px",
          backgroundColor: "#f9fdff",
          zIndex: 9,
          width: "100%",
          maxWidth: "1360px",
          m: "0 auto",
        }}
      >
        <MyPerformanceHeader {...headerProps} />
      </Box>
      <Paper elevation={3} className="drawer-paper-performance">
        <Box
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "1360px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {useTabbedView ? (
            <>
              {/* RBD keeps the welcome banner above the hero; the sales rep
                  greeting lives in MyPerformanceHeader instead. */}
              {roleKey === "RBD" && (
                <MyPerformanceWelcomeBanner
                  firstName={firstName}
                  nameLoading={displayIdentityLoading}
                  onExploreHcpClick={onExploreHcpClick}
                />
              )}
              <RoleMyPerformanceView
                roleKey={roleKey}
                widgetProps={widgetProps}
                selectedProduct={effectiveSelectedProduct}
              />
            </>
          ) : (
            <>
              {!isLeadership && (
                <MyPerformanceWelcomeBanner
                  firstName={firstName}
                  nameLoading={displayIdentityLoading}
                  onExploreHcpClick={onExploreHcpClick}
                />
              )}
              <DashboardRenderer roleKey={roleKey} widgetProps={widgetProps} />
            </>
          )}
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "#718096",
              mt: 2,
              textAlign: "center",
            }}
          >
            The numbers shown here are for reference only. For the official
            metrics that drive Incentive Compensation, please check MainSail.
          </Typography>
        </Box>
      </Paper>
    </>
  );
}

export default MyPerformance;
